/**
 * * Модель с информацией о текущем таймере
 */
export class CurrentTimerInfoModel {
  /**ID таймера */
  TimerId!: number;
  /**Дата старта */
  DateStart!: Date;

  constructor(obj?: Partial<CurrentTimerInfoModel>) {
    Object.assign(this, obj);
  }
}
